export function emit(type, event) {
  return function (_dispatch, _getState, context) {
    context.emitter.emit(type, event);
  };
}